import { processAssetData } from '@utils/assethelper'
import { getConfig } from '@configs/evnConfig'
import {
  FETCH_URL,
  DEFAULT_CHALLAN,
  APPFLYER_SEM_PMAX,
  APPFLYER_SEO,
  SEO_CHALLAN_PAGE,
  UTM_LEAD,
  DEFAULT_FASTAG,
  SEO_FASTAG_PAGE,
  DEFAULT_HSRP,
  SEO_HSRP_PAGE,
} from '@components/MainWidget/common/commonConstants'
import { VEHICLE_DATA, FASTAG_DATA, HSRP_DATA } from '@components/MainWidget/ChallanWidgetLanding/constants'
import { UtmLeadProductType } from '@enums/UtmLeadProduct'

export const getVehicleMMVStoreData = async challanUserData => {
  const assetImageResponse = await processAssetData(challanUserData?.vehicleInfo, FETCH_URL)
  const encodedData = btoa(
    JSON.stringify({ ...challanUserData, logo_url: assetImageResponse?.variantDetails?.logo_url })
  )
  localStorage.setItem(VEHICLE_DATA, encodedData)
}

export const getFastagMMVStoreData = async fastagUserData => {
  const encodedData = btoa(JSON.stringify(fastagUserData))
  localStorage.setItem(FASTAG_DATA, encodedData)
}

export const getHsrpMMVStoreData = async hsrpUserData => {
  const assetImageResponse = await processAssetData(hsrpUserData?.vehicleInfo, FETCH_URL)
  const encodedData = btoa(JSON.stringify({ ...hsrpUserData, logo_url: assetImageResponse?.variantDetails?.logo_url }))
  localStorage.setItem(HSRP_DATA, encodedData)
}

export const fetchDataFromLS = key => {
  const storedData = localStorage.getItem(key)
  if (storedData) {
    try {
      const decodedString = atob(storedData)
      const parsedData = JSON.parse(decodedString)
      return parsedData
    } catch (err) {
      console.error('Failed to decode or parse stored vehicleData:', err)
      localStorage.removeItem(key)
    }
  } else return null
}

export const getUtmLead = () => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(UTM_LEAD) || ''
  }
  return ''
}

const fastagUtmProductsMapping = {
  [UtmLeadProductType.SEM_FASTAG]: UtmLeadProductType.SEM_FASTAG,
  [UtmLeadProductType.PMAX_FASTAG]: UtmLeadProductType.PMAX_FASTAG,
  [UtmLeadProductType.BRANDFORMANCE_FASTAG]: UtmLeadProductType.BRANDFORMANCE_FASTAG,
  [UtmLeadProductType.META_FASTAG]: UtmLeadProductType.META_FASTAG,
}

const hsrpUtmProductsMapping = {
  [UtmLeadProductType.SEM_HSRP]: UtmLeadProductType.SEM_HSRP,
}

export const getProductName = () => {
  const utmLead = getUtmLead()

  const productMapping = {
    [UtmLeadProductType.SEM_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.PMAX_CHALLAN]: UtmLeadProductType.PMAX_CHALLAN,
    [UtmLeadProductType.META_CHALLAN]: UtmLeadProductType.META_CHALLAN,
    [UtmLeadProductType.WHATSAPP_WINBACK_CHALLAN]: UtmLeadProductType.WHATSAPP_WINBACK_CHALLAN,
    [UtmLeadProductType.BRANDFORMANCE_CHALLAN]: UtmLeadProductType.BRANDFORMANCE_CHALLAN,
    [UtmLeadProductType.INSTAGRAM_CHALLAN]: UtmLeadProductType.INSTAGRAM_CHALLAN,
    [UtmLeadProductType.ZEPTO_CHALLAN]: UtmLeadProductType.ZEPTO_CHALLAN,
    [UtmLeadProductType.ZOMATO_CHALLAN]: UtmLeadProductType.ZOMATO_CHALLAN,
    [UtmLeadProductType.CX_WA_WNBCK_CHLN_U1]: UtmLeadProductType.CX_WA_WNBCK_CHLN_U1,
    [UtmLeadProductType.CX_WA_WNBCK_CHLN_U2]: UtmLeadProductType.CX_WA_WNBCK_CHLN_U2,
    [UtmLeadProductType.CX_WA_WNBCK_CHLN_U3]: UtmLeadProductType.CX_WA_WNBCK_CHLN_U3,
    [UtmLeadProductType.CX_WA_WNBCK_CHLN_U4]: UtmLeadProductType.CX_WA_WNBCK_CHLN_U4,
    [UtmLeadProductType.CX_WA_WNBCK_CHLN_P1]: UtmLeadProductType.CX_WA_WNBCK_CHLN_P1,
    [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U1]: UtmLeadProductType.NCX_WA_WNBCK_CHLN_U1,
    [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U2]: UtmLeadProductType.NCX_WA_WNBCK_CHLN_U2,
    [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U3]: UtmLeadProductType.NCX_WA_WNBCK_CHLN_U3,
    [UtmLeadProductType.NCX_WA_WNBCK_CHLN_U4]: UtmLeadProductType.NCX_WA_WNBCK_CHLN_U4,
    [UtmLeadProductType.NCX_WA_WNBCK_CHLN_P1]: UtmLeadProductType.NCX_WA_WNBCK_CHLN_P1,
    [UtmLeadProductType.META_CHALLAN_INF1]: UtmLeadProductType.META_CHALLAN_INF1,
    [UtmLeadProductType.META_CHALLAN_INF2]: UtmLeadProductType.META_CHALLAN_INF2,
    [UtmLeadProductType.META_CHALLAN_INF3]: UtmLeadProductType.META_CHALLAN_INF3,
    [UtmLeadProductType.META_CHALLAN_INF4]: UtmLeadProductType.META_CHALLAN_INF4,
    [UtmLeadProductType.META_CHALLAN_INF5]: UtmLeadProductType.META_CHALLAN_INF5,
    [UtmLeadProductType.YT_CHALLAN_INF1]: UtmLeadProductType.YT_CHALLAN_INF1,
    [UtmLeadProductType.YT_CHALLAN_INF2]: UtmLeadProductType.YT_CHALLAN_INF2,
    [UtmLeadProductType.YT_CHALLAN_INF3]: UtmLeadProductType.YT_CHALLAN_INF3,
    [UtmLeadProductType.YT_CHALLAN_INF4]: UtmLeadProductType.YT_CHALLAN_INF4,
    [UtmLeadProductType.YT_CHALLAN_INF5]: UtmLeadProductType.YT_CHALLAN_INF5,
  }

  return productMapping[utmLead] || DEFAULT_CHALLAN
}

export const getFastagProductName = () => {
  const utmLead = getUtmLead()
  return fastagUtmProductsMapping[utmLead] || DEFAULT_FASTAG
}

export const getHsrpProductName = () => {
  const utmLead = getUtmLead()
  return hsrpUtmProductsMapping[utmLead] || DEFAULT_HSRP
}

export const getSourceName = () => {
  const utmLead = getUtmLead()

  const productMapping = {
    [UtmLeadProductType.SEM_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.PMAX_CHALLAN]: UtmLeadProductType.PMAX_CHALLAN,
    [UtmLeadProductType.META_CHALLAN]: UtmLeadProductType.META_CHALLAN,
    [UtmLeadProductType.WHATSAPP_WINBACK_CHALLAN]: UtmLeadProductType.WHATSAPP_WINBACK_CHALLAN,
    [UtmLeadProductType.BRANDFORMANCE_CHALLAN]: UtmLeadProductType.BRANDFORMANCE_CHALLAN,
    [UtmLeadProductType.INSTAGRAM_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.ZEPTO_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.ZOMATO_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.META_CHALLAN_INF1]: UtmLeadProductType.META_CHALLAN_INF1,
    [UtmLeadProductType.META_CHALLAN_INF2]: UtmLeadProductType.META_CHALLAN_INF2,
    [UtmLeadProductType.META_CHALLAN_INF3]: UtmLeadProductType.META_CHALLAN_INF3,
    [UtmLeadProductType.META_CHALLAN_INF4]: UtmLeadProductType.META_CHALLAN_INF4,
    [UtmLeadProductType.META_CHALLAN_INF5]: UtmLeadProductType.META_CHALLAN_INF5,
    [UtmLeadProductType.YT_CHALLAN_INF1]: UtmLeadProductType.YT_CHALLAN_INF1,
    [UtmLeadProductType.YT_CHALLAN_INF2]: UtmLeadProductType.YT_CHALLAN_INF2,
    [UtmLeadProductType.YT_CHALLAN_INF3]: UtmLeadProductType.YT_CHALLAN_INF3,
    [UtmLeadProductType.YT_CHALLAN_INF4]: UtmLeadProductType.YT_CHALLAN_INF4,
    [UtmLeadProductType.YT_CHALLAN_INF5]: UtmLeadProductType.YT_CHALLAN_INF5,
  }

  return productMapping[utmLead] || SEO_CHALLAN_PAGE
}

export const getFastagSourceName = () => {
  const utmLead = getUtmLead()

  const fastagUtmSourcesMapping = {
    [UtmLeadProductType.SEM_FASTAG]: UtmLeadProductType.SEM_FASTAG,
    [UtmLeadProductType.PMAX_FASTAG]: UtmLeadProductType.PMAX_FASTAG,
    [UtmLeadProductType.BRANDFORMANCE_FASTAG]: UtmLeadProductType.BRANDFORMANCE_FASTAG,
    [UtmLeadProductType.META_FASTAG]: UtmLeadProductType.META_FASTAG,
  }

  return fastagUtmSourcesMapping[utmLead] || SEO_FASTAG_PAGE
}

export const getHsrpSourceName = () => {
  const utmLead = getUtmLead()

  return hsrpUtmProductsMapping[utmLead] || SEO_HSRP_PAGE
}

export const getApiKeyLead = currentEnv => {
  const utmLead = getUtmLead()

  const productMapping = {
    [UtmLeadProductType.SEM_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.PMAX_CHALLAN]: UtmLeadProductType.PMAX_CHALLAN,
    [UtmLeadProductType.META_CHALLAN]: UtmLeadProductType.META_CHALLAN,
    [UtmLeadProductType.SEO_CHALLAN]: UtmLeadProductType.SEO_CHALLAN,
    [UtmLeadProductType.INSTAGRAM_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.ZEPTO_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.ZOMATO_CHALLAN]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.META_CHALLAN_INF1]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.META_CHALLAN_INF2]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.META_CHALLAN_INF3]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.META_CHALLAN_INF4]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.META_CHALLAN_INF5]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.YT_CHALLAN_INF1]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.YT_CHALLAN_INF2]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.YT_CHALLAN_INF3]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.YT_CHALLAN_INF4]: UtmLeadProductType.SEM_CHALLAN,
    [UtmLeadProductType.YT_CHALLAN_INF5]: UtmLeadProductType.SEM_CHALLAN,
  }

  if (utmLead && productMapping[utmLead]) {
    return getConfig(currentEnv)?.autoVasConfig?.apiKeySem[productMapping[utmLead]]
  }
  return getConfig(currentEnv)?.autoVasConfig?.apiChallanKeyWithouUtm
}

export const getFallBackQRDownloadUrl = () => {
  const utmLead = getUtmLead()

  const productMapping = {
    SEM_CHALLAN: APPFLYER_SEM_PMAX,
    PMAX_CHALLAN: APPFLYER_SEM_PMAX,
    META_CHALLAN: APPFLYER_SEM_PMAX,
  }

  return productMapping[utmLead] || APPFLYER_SEO
}

export const getFastagApiKeyLead = currentEnv => {
  const utmLead = getUtmLead()
  if (utmLead && fastagUtmProductsMapping[utmLead]) {
    return getConfig(currentEnv)?.autoVasConfig?.apiKeySem[fastagUtmProductsMapping[utmLead]]
  }
  return getConfig(currentEnv)?.autoVasConfig?.apiFastagKeyWithoutUtm
}

export const getHsrpApiKeyLead = currentEnv => {
  const utmLead = getUtmLead()
  if (utmLead && hsrpUtmProductsMapping[utmLead]) {
    return getConfig(currentEnv)?.autoVasConfig?.apiKeySem[hsrpUtmProductsMapping[utmLead]]
  }
  return getConfig(currentEnv)?.autoVasConfig?.apiHsrpKeyWithoutUtm
}
